/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ChipCshcnRatesTableHead } from './TableHead';

import Spinner from '../../../../SharedModules/Spinner/Spinner';

export default function DispChipCshcnRates() {
  const dispatch = useDispatch();
  const [resultList, setResultList] = React.useState([]);
  const { isLoading, searchResult, rebateProgramName, quarterValue } =
    useSelector((state) => state?.sharedState?.ChipCshcnRatesReducer);
  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgramName;

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  // API call for Grid
  // useEffect(() => {
  //   dispatch(
  //     getResultGridChipCshcnRates({
  //       rebateProgramCd: rebateProgramValue,
  //       quarter: quarterValue,
  //       mfgId: manufacturerSelected,
  //       alAll: manufacturerSelected[0] === 'ALL' ? 1 : 0,
  //     })
  //   );
  // }, []);

  React.useEffect(() => {
    let updatedSearchResult = searchResult || [];
    updatedSearchResult = updatedSearchResult.map((item) => {
      return {
        ...item,
        calcUra: item.calcUra ? item.calcUra.toFixed(4) : '0.0000',
      };
    });
    setResultList(updatedSearchResult);
  }, [searchResult]);

  const firstInfo = `Quarter : ${quarterValue}`;
  const thirdInfo = `${rebateProgramNameValue}`;
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display CHIP/CSHCN Rates"
          />
          <Spinner load={isLoading} />
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Rebate Program : "
                  id="Rebate Program"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={rebateProgramNameValue}
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Calculated Quarter :"
                  id="Calculated Quarter"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={quarterValue}
                  name="quarter"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGridWithFeatures
        suppressCellFocus
        isScrollOn
        rowData={resultList}
        columnDefs={ChipCshcnRatesTableHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,

          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 20) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
        reportName="CHIP CSHCN Rates Report"
        fileName="CHIP_CHSCN RATES AUDIT"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, thirdInfo }}
        // pinnedBottomRowData={pinnedBottomRowData}
      />
    </div>
  );
}
